<template>
    <v-container style="padding-top:70px">
        <div v-if="showcargando == true" id="cargando" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row class="ma-1 ">
            <v-card width="100%" class="mx-2">
                <Menu></Menu>
            </v-card>

        </v-row>
        <v-row>
            <v-col cols="12" md="12">
                <v-card flat class="text-xs-center ma-3" width="100%">
                    <v-card-title class=" primary">
                        <span class="card-title-text" style="color: white;">Seguimiento {{ clclave }}</span>
                    </v-card-title>
                    <v-card-text>
                        <br />
                        <DataTable v-if="ver" :url="url" :columns="head" :params="displayInputs" :order="[[0, 'desc']]"
                            select="multiple" @input="seleccionarReportes" @apiDT="apiDT = $event">
                        </DataTable>

                        <v-row justify="center">
                            <v-btn class="ma-2" :disabled="loadingB" @click="Guardar()" color="success">
                                Guardar
                                <template v-slot:loader>
                                    <span>Loading...</span>
                                </template>
                            </v-btn>

                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card flat class="text-xs-center ma-3" width="100%" v-if="editar">
                    <v-card-title class=" primary">
                        <span class="card-title-text" style="color: white;">Seguimiento {{ clclave }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-row>
                                <v-col cols="12" md="6" offset-md="3">

                                    <span style="color: black;">Reporte:</span>
                                    <span style="color: black;">{{ reporte }}</span>
                                </v-col>
                                <v-col cols="12" md="6" offset-md="3">

                                    <span style="color: black;">Observación:</span>
                                    <v-textarea :counter="$store.state.maxLengthComentarios" :rules="rulestextarea"
                                        outlined v-model="observacion" required name="input-7-4"></v-textarea>

                                </v-col>
                            </v-row>
                            <v-row justify="center" class="mb-8">
                                <v-btn @click="GuardarEdiciom()" class="ma-2" color="primary">
                                    Guardar
                                    <template v-slot:loader>
                                        <span>Loading...</span>
                                    </template>
                                </v-btn>
                                <v-btn @click="Limpiar()" class="ma-2">
                                    Limpiar
                                </v-btn>
                                <v-btn color="error" @click="Regresar()" class="ma-2">
                                    Regresar
                                </v-btn>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';
import Menu from '@/components/pages/operacion/MenuEstadisticas/Menu.vue';
import DataTable from "@/components/pages/DataTableNet/DataTable";
import General from "@/services/Operacion/Operacion.service.js";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import UtilidadesServ from '@/services/Utilidades/Utilidades.service.js';

export default {
    components: {
        Menu,
        DataTable,
    },
    data() {
        return {
            valid: true,
            showcargando: true,
            apiDT: null,
            displayInputs: {},
            url: "Operacion/SeguimientoAtlas",
            head: [
                { name: "reporte", data: "reporte", title: "Reporte", },
                { name: "svfhreporte", data: "svfhreporte", title: "Fecha Reporte" },
                { name: "svnumsin", data: "svnumsin", title: "Num. Siniestro" },
                { name: "Concepto", data: "Concepto", title: "Concepto" },
                { name: "flotilla", data: "flotilla", title: "Flotilla" },
                { name: "abogado", data: "abogado", title: "Abogado" },
                { name: "svnumave", data: "svnumave", title: "Num. Carpeta", }
            ],
            formatterActions: [
                { click: [this, "editarTercerodisabled"] }
            ],
            ver: false,
            loadingB: true,
            seleccion: [],
            editar: false,
            reporte: '',
            observacion: '',
            exid: 0,
            rulestextarea: [
                v => !!v || 'Campo requerido',
                v => {
                    if (v == null) {
                        return true
                    }
                    else {
                        if (v.length <= 12) {
                            return 'Mínimo 12 Carácteres'
                        }
                        else if (v.length > this.$store.state.maxLengthComentarios) {
                            return "Máximo " + this.$store.state.maxLengthComentarios + " Carácteres"
                        }
                        else
                            return true
                    }
                },
            ],
            clclave: '',
        }
    },
    watch: {
        seleccion() {
            if (this.seleccion.length > 0)
                this.loadingB = false;
            else
                this.loadingB = true;
        }
    },
    methods: {
        async GuardarEdiciom() {
            let id = this.exid;
            let obs = this.observacion;
            let tam = this.observacion.length;
            if (this.$refs.form.validate()) {
                this.apiDT.data().map(function (datos) {
                    console.log("ASa", datos.exid, id);
                    if (datos.exid == id) {
                        datos.exobs = obs;
                        datos.tamaño = tam;
                        console.log(datos);
                    }

                    return datos;
                });

                console.log(this.apiDT.data());
                this.apiDT.draw(true);
                this.apiDT.responsive();
                this.editar = false;


            }
        },
        Limpiar() {
            this.$refs.form.reset();
        },
        Regresar() {
            this.editar = false;
        },
        Guardar() {

            let formdata = new FormData();
            formdata.append("parametros", JSON.stringify(this.seleccion));
            formdata.append("clclave", this.clclave);
            this.$swal({
                position: "center",
                title: "Procesando Seguimiento ...",
                allowOutsideClick: false,
                allowEscapeKey: false,
                confirm: false,
            });
            this.$swal.showLoading();
            UtilidadesServ.GuardarSeguimentoAtlas(formdata).then(data => {
                let msg = '';
                for (var i = 0; i < data.length; i++) {

                    msg += "||Reporte: " + data[i].nrreporte + "-" + data[i].svindice + "   ";
                    if (data[i].nomArchivo != null)
                        msg += "      ||Documento: " + data[i].nomArchivo + "    ";
                    msg += "    ||Respuesta: " + data[i].error + "</br></br>";
                }
                this.$swal(
                    "Atención",
                    msg,
                    'info'
                );
                this.seleccion = [];
                this.reloadTable();
                this.loadingB = true;


                this.reloadTable();
            });

        },
        Eliminar() {
            let formdata = new FormData();
            formdata.append("parametros", JSON.stringify(this.seleccion));
            UtilidadesServ.EliminarSeguimiento(formdata);
            this.reloadTable();
            this.seleccion = [];
        },
        async editarTercerodisabled(params, item, fila) {
            this.editar = true;
            this.exid = item.exid;
            this.reporte = item.reporte;
            this.observacion = item.exobs;
        },
        formatearTexto(x) {

        },
        formatearEditar(x) {
            if (x.editar == 1) {
                return `<button type="button" data-action="0" data-params="${x}" class=" dt-formatterAction v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary"><span class="v-btn__content"><span style="color: white;">Editar</span></span></button>`;

            }
            return ``;
        },
        seleccionarReportes(reporte) {
            console.log("reporte", reporte)
            this.seleccion = reporte;
        },
        reloadTable() {
            if (this.apiDT != null) {
                this.apiDT.ajax.reload(null, false);
                this.apiDT.columns.adjust().responsive.recalc();
            }
        },
    },
    async mounted() {
        let dato = await MetodosGenerales.obtenerSessionReporte("param");
        this.clclave = dato.clclave
        this.showcargando = false;
        this.displayInputs = {
            clclave: this.clclave,
        };
        this.ver = true;
    },
    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '325').then(response => {

            if (response.data.length > 0) {
            } else {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
            }

        });
    },
    computed: {
        ...mapState({ drawer: (state) => state.drawer }),
        ...mapState(["domain", "informationPage"]),
        DRAWER_STATE: {
            get() {
                return this.drawer;
            },
        },
    },
}
</script>